export enum SSLInspectionStatus {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
  BASE = 'base',
}

export interface SSLInspectionData {
  sslInspection: SSLInspectionStatus
}

export interface GetSSLInspectionConfigResponse {
  data: SSLInspectionData
}

export type UpdateSSLInspectionPayload = GetSSLInspectionConfigResponse
